/**
 * Import de lodash de manière globale dans l'appli
 */
import Vue from 'vue'
import _ from 'lodash'

Vue.prototype._ = _
